module.exports = __webpack_public_path__ + "img/nu_logo_r.53c3c0be.53c3c0be.png";